import { render, staticRenderFns } from "./ConsultantsTable.vue?vue&type=template&id=22784f94&"
import script from "./ConsultantsTable.vue?vue&type=script&lang=js&"
export * from "./ConsultantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports